/** Privilege level of a group or role (Feature #6256), as the UserMaster API sends it (AccessType enum, an int). */
export enum AccessType {
  Standard = 0,
  Global = 1,
}
